export class UrlMaskQualifier {
    constructor() {
        this.key = "UrlMask";
    }
    process() {
        return window.location.href.replace(/#$/, '');
    }
}
